<template>
  <div class="help-tooltip">
    <e-tooltip :max-width="maxWidth">
      <template #activator>
        <e-icon
          name="question"
          :size="iconSize"
          :class="{ 'text-blue': variant === 'primary', 'text-ordinary': variant === 'ordinary' }"
        />
      </template>
      <div class="paragraph-xs text-secondary">
        <slot />
      </div>
    </e-tooltip>
  </div>
</template>

<script setup lang="ts">
import { EIcon, ETooltip } from '@/core/components/ui';

withDefaults(
  defineProps<{
    variant?: 'primary' | 'ordinary';
    maxWidth?: string | number;
    iconSize?: number;
  }>(),
  {
    variant: 'ordinary',
    maxWidth: '250',
    iconSize: 20,
  },
);

defineSlots<{
  default: () => void;
}>();
</script>

<style scoped lang="scss">
.help-tooltip {
  display: inline-block;

  line-height: 0.5;
  vertical-align: middle;
}
</style>
